import { InvoiveCountTableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { InvoiceCountType } from "../../../redux/listing/listingTypes";
import { TableHeader, TableLoader } from "../../commons";
import InvoiceTableData from "./InvoiceTableData";

type AppProps = {
  fetching: boolean;
    tableHeaders: InvoiveCountTableHeadersType[];
  data:[] | InvoiceCountType[];
}


const InvoiveCountTable = ({
    tableHeaders,
  fetching,
  data

}: AppProps) => {

    return <>
    {
        fetching ? <TableLoader
          Rows={10}
          ColumnPerRow={4}
        /> :
          <div className="jobsType">
                <table className="table thead-light table-bordered">
                  <thead className='text-left sticky-table-header'>
                    <TableHeader
                      tableHeader={tableHeaders}
                    />
                  </thead>
                  <tbody>
                    <InvoiceTableData
                      tableHeaders={tableHeaders}
                      data={data}
                    />
                  </tbody>
                </table>
          </div>
      }
    </>
 }

export default InvoiveCountTable